<template>
  <div class="m_container">
    <Header :title="title" :show-left="true" />
    <section v-loading="loading" class="m_section">
      <div v-if="issubmit !== '3'">
        <div class="content">
          <div class="form_list" :class="{'member_form_list':detail.thumb_url}">
            <p v-if="detail.thumb_url" class="pic">
              <img :src="detail.thumb_url" alt="" class="img">
            </p>
            <div class="form_item">
              <p class="form_label">姓名</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.name? detail.name : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">手机号</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.mobile? detail.mobile : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">身份证</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.id_card ? detail.id_card : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">科目</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.subject ? detail.subject : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">考级</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.level ? detail.level : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">地区</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.region ? detail.region : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">地址</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.address ? detail.address : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">国籍</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.nationality ? detail.nationality : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">民族</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.nation ? detail.nation : '' }}</p>
            </div>
            <div class="form_item">
              <p class="form_label">报名费</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.subject_fee ? detail.subject_fee : '' }}元</p>
            </div>
            <div class="form_item">
              <p class="form_label">邮费</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.express_fee ? detail.express_fee : '' }}元</p>
            </div>
            <div class="form_item">
              <p class="form_label">合计费用</p>
              <p class="color_9 maohao">:</p>
              <p class="form_value">{{ detail.total_fee ? detail.total_fee : '' }}元</p>
            </div>
            <div class="form_item">
              <p class="form_label">状态</p>
              <p class="color_9 maohao">:</p>
              <p v-if="detail.status === 0" class="form_value">未支付</p>
              <p v-if="detail.status === 1" class="form_value">已支付</p>
              <p v-if="detail.status === 2" class="form_value">申请退款</p>
              <p v-if="detail.status === 3" class="form_value">退款成功</p>
            </div>
          </div>
        </div>
        <div v-if="issubmit === '1'" class="footer">
          <el-button type="info" class="submitbtn" @click="back('/myExam')">取消</el-button>
          <el-button type="primary" class="submitbtn" @click="confirm">确定</el-button>
        </div>
      </div>
      <div v-else class="receipt-wrapper">
        <div class="hd">
          <h2>{{ admissionDetail.title }}</h2>
          <p>编号：{{ admissionDetail.admission_number }}</p>
        </div>
        <div class="table_body">
          <div ref="con_left" class="con_left uls">

            <div class="lis_wrap">
              <div class="lis">
                <p class="f_label">姓名</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.name }}</p>
              </div>
              <div class="lis">
                <p class="f_label">性别</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.gender ===2 ? '女' : '男' }}</p>
              </div>
              <div class="lis">
                <p class="f_label">出生日期</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.birthday }}</p>
              </div>
              <div class="lis">
                <p class="f_label">手机号</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.mobile }}</p>
              </div>
              <div class="lis">
                <p class="f_label">国籍</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.nationality }}</p>
              </div>
              <div class="lis">
                <p class="f_label">民族</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.nation }}</p>
              </div>
              <div class="lis">
                <p class="f_label">报考科目</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.subject_name }}</p>
              </div>
              <div class="lis">
                <p class="f_label">报考级别</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.level_name }}</p>
              </div>
              <div class="lis">
                <p class="f_label">考级时间</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.exam_at }}</p>
              </div>
              <div class="lis">
                <p class="f_label">考级教室</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.exam_classroom }}</p>
              </div>
              <div class="lis">
                <p class="f_label">考级地点</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.exam_address }}</p>
              </div>
              <div class="lis">
                <p class="f_label">理论考试</p>
                <p class="color_9 maohao">:</p>
                <p class="f_val">{{ admissionDetail.is_theory ? '是': '否' }}</p>
              </div>
            </div>

          </div>
          <div class="con_right" :style="{height:contentHeight}">
            <!-- 作品 -->
            <div v-if="admissionDetail.thumb_url" class="img_wrap">
              <img :src="admissionDetail.thumb_url" alt="">
            </div>
          </div>
        </div>
        <p class="tip">考级注意事项：{{ admissionDetail.note }}</p>
      </div>
    </section>
    <TabBar v-if="issubmit !=='3'" :current-tab="currentTab" />
    <!-- 非微信浏览器选择支付方式：微信支付、支付宝支付 -->
    <el-dialog title="请选择支付方式" :visible.sync="dialogVisible" :append-to-body="true" width="80%">
      <el-radio-group v-model="h5_pay_type">
        <el-radio label="wx">微信</el-radio>
        <el-radio label="ali">支付宝</el-radio>
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="hanleH5Pay">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import wx from 'weixin-js-sdk'
import { mapGetters } from 'vuex'
import { getSid, setSid } from '@/utils/cookies'
import { getId, getIsSubmit, getSubjectId, getLevelId, getMemberId } from '@/utils/cookie_confirmExam'
import { signupConfirmInfo, submitInfo, admissionDetail } from '@/api/SignupSubject'
import { h5Wechatpay, h5Alipay, wxWechatPay } from '@/api/SignupInfo'
import { getCode, getWxConfig } from '@/api/wechat'
import { getUrlKey } from '@/utils/common'

export default {
  name: 'ConfirmExam',
  components: { Header, TabBar },
  data() {
    return {
      sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
      aid: this.$route.query.id ? this.$route.query.id : getId(),
      issubmit: this.$route.query.issubmit ? this.$route.query.issubmit : getIsSubmit(),
      temp: {
        id: this.$route.query.id ? this.$route.query.id : getId(),
        sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
        subject_id: this.$route.query.sd ? this.$route.query.sd : getSubjectId(),
        level_id: this.$route.query.ld ? this.$route.query.ld : getLevelId(),
        member_id: this.$route.query.md ? this.$route.query.md : getMemberId()
      },
      title: '确认信息',
      loading: false,
      currentTab: '',
      detail: '',
      admissionDetail: '',
      contentHeight: '0',
      client: '', // 判断是微信浏览器还是普通浏览器
      dialogVisible: false,
      h5_pay_type: 'wx'
    }
  },

  computed: {
    ...mapGetters(['openid'])
  },

  created() {
    console.log('created-----issubmit', this.issubmit)
    this.sid ? setSid(this.sid) : ''
    this.initPage(this.issubmit)
  },

  methods: {
    initPage(issubmit) { // 初始化页面：【详情页 ， 确认信息页， 准考证】
      switch (issubmit) {
        case '0':
          this.title = '详情'
          this.getSignupConfirmInfo()

          break

        case '1': // 确认信息
          !this.temp.id || this.temp.id === 'undefined' ? this.temp.id = '' : ''
          this.initWXPage() // 初始化微信配置页面后 获取详情getSignupConfirmInfo
          break

        case '3':
          this.title = '准考证'
          this.getAdmissionDetail(this.aid)

          break

        default:
          break
      }
    },

    async initWXPage() { // 微信浏览器 获取code、openid、配置jssdk
      this.client = await this.judgeIsWeixin() //  判断是微信浏览器还是普通浏览器

      this.getSignupConfirmInfo()

      if (this.client === 'wx' && !this.openid) { // 若是微信浏览器 openid不存在 ：若code存在就code换取openid 若code不存在就获取code
        const code = getUrlKey('code')
        const current_url = window.location.href.split('?')[0]

        const state_arr = window.location.href.split('?')[1].split('&')
        const state_json = {}
        state_arr.map(item => {
          state_json[item.split('=')[0]] = item.split('=')[1]
        })

        code ? this.getOpenid(code) : this.getCode(current_url, JSON.stringify(state_json)) // code存在就通过code获取openid，否则就获取code
      } else if (this.client === 'wx' && this.openid) { // 若是微信浏览器 openid存在
        await this.handleWXConfig({ url: encodeURIComponent(process.env.VUE_APP_H5_URL) }) // 获取jssdk配置信息
      }
    },

    getSignupConfirmInfo() { // 获取报名确认信息
      signupConfirmInfo(this.temp).then(res => {
        if (res.code === 200) {
          this.detail = res.data
          this.detail.region = this.detail.region.toString().replace(new RegExp(',', 'g'), '/')
        }
      })
    },

    judgeIsWeixin() { // 判断当前浏览器是微信浏览器还是普通浏览器
      return new Promise(resolve => {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('micromessenger') !== -1) {
          console.log('微信浏览器')
          resolve('wx')
        } else {
          console.log('不是微信浏览器')
          resolve('h5')
        }
      })
    },

    handleH5Wechatpay() { // 1、h5浏览器 微信支付
      h5Wechatpay({ id: this.aid }).then(res => {
        if (res.code === 200) {
          window.location.replace(res.data.url)
        }
      })
    },

    handleH5Alipay() { // 1、h5浏览器 支付宝支付
      // window.location.replace(`${process.env.VUE_APP_BASE_API}/api/signup/info/h5Alipay?id=${this.aid}`)
      h5Alipay({ id: this.aid }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          const div = document.createElement('div') // 创建div
          div.innerHTML = res.data // 将返回的form 放入div
          document.body.appendChild(div)
          document.forms[0].submit()
        }
      })
    },

    getCode(url, state) { // 2、微信浏览器 公众号登录获取微信code
      getCode({ url, state }).then(res => {
        console.log('getcode => res', res.data)

        setTimeout(() => {
          window.location.replace(res.data.url)
        }, 2000)
      })
    },

    async getOpenid(code) { // 2、微信浏览器 已经有code，用code获取公众号openid 并获取jssdk配置
      this.openid = await this.$store.dispatch('wechat/getOpenid', { code })
      this.handleWXConfig({ url: encodeURIComponent(process.env.VUE_APP_H5_URL) }) // 微信公众号支付 ：获取jssdk配置信息
    },

    handleWXConfig(params) { // 获取jssdk配置信息
      return new Promise(resolve => {
        getWxConfig(params).then(res => {
          const { appId, timestamp, nonceStr, signature, jsApiList } = res.data.signPackage

          wx.config({ //  通过后端
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId, // 必填，公众号的唯一标识
            timestamp, // 必填，生成签名的时间戳
            nonceStr, // 必填，生成签名的随机串
            signature, // 必填，签名，见附录1
            jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          resolve()
        })
      })
    },

    confirm() { // 确认 报名
      const that = this
      this.$confirm('确认提交后不可再修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          submitInfo(this.temp).then(res => {
            this.saveLoading = false
            if (res.code === 200) {
              this.aid = res.data.id

              if (this.client === 'wx') { // 微信浏览器支付 （微信公众号支付）
                // 获取该笔订单支付配置信息
                wxWechatPay({ id: this.aid, openid: this.openid }).then(res => {
                  const { timeStamp, nonceStr, packageStr, paySign, signType } = res.data

                  wx.chooseWXPay({
                    timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                    nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
                    package: packageStr, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                    signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                    paySign: paySign, // 支付签名
                    success: function (res) { // 支付成功后的回调函数
                      if (res.err_msg === 'get_brand_wcpay_request:ok' || res.errMsg === 'chooseWXPay:ok') {
                        that.$router.push({ path: '/myExam', query: { sid: this.sid }})
                      }
                    },
                    complete: res => {
                      if (res.err_msg === 'get_brand_wcpay_request:ok' || res.errMsg === 'chooseWXPay:ok') {
                        that.$router.push({ path: '/myExam', query: { sid: this.sid }})
                      }
                    }
                  })
                })
              } else { // h5支付
                this.dialogVisible = true
              }
            }
          }).catch(() => { this.saveLoading = false })
        })
        .catch(() => {})
    },

    hanleH5Pay() { // h5浏览器：拉起微信支付或者支付宝支付
      console.log('this.h5_pay_type', this.h5_pay_type)
      this.h5_pay_type === 'wx' ? this.handleH5Wechatpay() : this.handleH5Alipay()
    },

    getAdmissionDetail(id) { // 获取准考证详情
      this.loading = true
      admissionDetail({ sid: this.sid, id }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.admissionDetail = res.data
          this.$nextTick(() => {
            this.contentHeight = this.$refs.con_left.clientHeight + 'px'
          })
        }
      }).catch(() => { this.loading = false })
    },

    back(url) {
      this.$route.path !== url ? this.$router.push({ path: url }) : ''
    },

    print() {
      this.$confirm('请复制链接至电脑端打印', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.m_container{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f5f5;

  .m_section {
    flex:1;

    .content{
      margin: 10px;
      padding: 5px;
      background: #fff;

      .title{
        padding: 5px 0;
        font-size: 18px;
        font-weight: bold;
      }

      .member_form_list{
        padding-top: 120px;
      }

      .form_list{
        margin-top: 10px;

        .pic{
           width: 94px;
           margin: 0 auto 30px;
           position: absolute;
           top: 70px;
           left: 50%;
           transform: translateX(-50%);

           .img{
             width: 88px;
           }
         }

        .form_item{
          padding: 0px 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: #4d4c4c;

          .form_label{
            width: 80px;
            color:#999;
            text-align: right;
            margin-right: 10px;
            display: inline-block;
            text-align: justify;
            text-align-last: justify;
            text-justify: inter-ideograph;
            // height: 40px;
            // line-height:0px;

            &:after {
            //  content: '';
            //  width: 100%;
            //  display: inline-block;
              display: inline-block;/*行内元素*/
              content: '';
              width: 100%;/*可以挤掉文字，保证不跟文字在同一行*/
              height: 0;
              visibility: hidden;
            }
          }

          .maohao{
            margin-top:-14px;
          }

          .form_value{
            flex: 1;
            padding: 0 10px;
            text-align: left;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-top:-14px;

            .img{
              width: 40px;
            }

            .img_wrap{
              display: flex;
              align-items: center;

              .img{
                margin: 0 5px;
              }
            }
          }
        }
      }
    }

    .footer{
      margin: 20px 10px 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .submitbtn{
      width: 90%;
    }

    .qr{
      margin-bottom:10px;
    }
  }
}
.imgDialog /deep/ .el-dialog{
  width:90%;

  img{
    width: 100%;
    height:100%;
  }
}

.receipt-wrapper{
  padding:20px 16Px 0;
  line-height: 26Px;
  font-size: 12Px;

  .hd{
    padding: 25px 10px 15px;
    background: #fff;
    line-height: 20Px;
    border-bottom: 1px solid #f5f5f5;

    h2{
      font-size: 20Px;
      text-align: center;
      font-family: PingFang;
      margin-bottom: 10Px;
    }

    p{
      text-align: center;
      line-height: 20Px;
      font-size: 12px;
      color:#999;
    }
  }

  .table_body{
    width: 100%;
    padding: 10px 10px 10px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .con_left{
      flex: 3;

      .lis{
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: left;
        font-size: 12px;

        .f_label{
          flex:1;
          padding: 4Px 6Px;
          color: #999;
          display: inline-block;
          text-align: justify;
          text-align-last: justify;
          line-height: 12px;

          &:after {
             display: inline-block;/*行内元素*/
              content: '';
              width: 100%;/*可以挤掉文字，保证不跟文字在同一行*/
              // height: 0;
              // visibility: hidden;
          }
        }

        .maohao{
          margin-top: -10px;
        }

        .f_val{
          flex: 2;
          padding: 0 10Px;
          margin:0;
          margin-top: -10px;
          // height: 40px;
          // line-height: 40px;
        }
      }
    }

    .con_right{
      flex: 1;
      width:100%;
      padding: 10px 0;
      display:flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      .img_wrap{
        // flex: 1;
        width:100%;
        display:flex;
        justify-content: center;
        align-items: center;

        img{
          width:90Px;
        }
      }
    }
  }

  .tip{
    background: #fff;
    padding: 6px 10px;
    text-align: left;
    font-size: 6px;
  }

  .center_flex{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .submitbtn{
    margin: 10px auto;
    text-align: center;
    padding: 8Px 12Px;
    font-size: 12Px;
    width: 100px!important;
  }
}

</style>

